<template>
  <v-menu
      offset-y
      min-width="290px"
      ref="menu"
      transition="scale-transition"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
  >
    <template v-slot:activator="{ on, attrs }">
      <ValidationProvider :name="$attrs.label" :rules="rules" v-slot="{ errors, valid }">
        <v-text-field
            readonly
            class="pt-5"
            prepend-icon="mdi-calendar"
            v-model="date"
            v-bind="Object.assign(attrs, $attrs)"
            v-on="on"
            :label="$t(`label.${$attrs.label}`)"
            :error-messages="errors.concat($attrs.errors || [])"
            :success="date > 0 && valid"
            :disabled="$attrs.disabled"
        />
      </ValidationProvider>
    </template>
    <v-date-picker
        min="1930-01-01"
        :disabled="$attrs.disabled"
        :max="new Date().toISOString().substr(0, 10)"
        :type="type"
        v-model="date"
        @input="menu = false"
        @change="save"
    />
  </v-menu>
</template>

<script>
import {ValidationProvider} from "vee-validate";

export default {
  components: {
    ValidationProvider
  },
  props: {
    rules: {
      type: [Object, String],
      default: ""
    },
    // must be included in props
    value: {
      type: null
    },
    type: {
      type: [String],
      default: 'date'
    }
  },
  data: () => ({
    menu: false,
    date: null,
  }),
  watch: {
    // Handles internal model changes.
    date(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.date = newVal;
    }
  },
  created() {
    if (this.value) {
      this.date = this.value;
    }
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date)
    },
  },
};
</script>
